var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"NavToggle",class:_vm.activeClass,on:{"click":_vm.toggle}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"NavToggle__inner"})])
}]

export { render, staticRenderFns }